// extracted by mini-css-extract-plugin
export default {"mCard":"DA-z","image":"EA-z","imageNoBackground":"FA-z","imageHasCategory":"GA-z","fullWidth":"HA-z"};